import { getMicroAppPathAfterBase } from 'components/apps/fullscreen/microApp/utils'
import { environment } from 'environment'

interface Params {
  stableId: string
  currentBaseUrl: string
  bundleUrl: string
  libraryType: string
  container: HTMLElement
  devhubAppVersionId: string
}

export const createIframeElement = ({
  stableId,
  currentBaseUrl,
  bundleUrl,
  libraryType,
  container,
  devhubAppVersionId,
}: Params): HTMLIFrameElement => {
  const encodedBundleUrl = encodeURIComponent(bundleUrl)
  const initialPath = getMicroAppPathAfterBase(currentBaseUrl)
  const encodedInitialPath = initialPath === '/' ? '/' : encodeURIComponent(initialPath)

  // explict CG IDs,              Prod                                    Staging
  const campaignGoveranceId = ['f39411d8-0f5b-4dfa-bd94-e8d824b5410a', '0d9b9b23-9eed-48ea-8a47-27e4f5a429de']
  // we aren't ready for this to be pushed live so we are only enabling it for the campaign goverance team
  let subdomain = stableId
  if (campaignGoveranceId.includes(devhubAppVersionId)) {
    subdomain = devhubAppVersionId
  }

  const IFRAME_APP_LAUNCHER_URL = `https://${subdomain}.apps.${environment.ENV_BASE_URL}`

  const iframe = document.createElement('iframe')
  iframe.id = stableId
  iframe.style.cssText = 'width: 100%; flex-grow: 1; border: none;'
  iframe.allow = 'clipboard-write'

  iframe.src = `${IFRAME_APP_LAUNCHER_URL}?bundleUrl=${encodedBundleUrl}&initialPath=${encodedInitialPath}&libraryType=${libraryType}`

  container.appendChild(iframe)

  return iframe
}
